import React from 'react';
import { Link } from 'react-router-dom';

const Impressum = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="bg-white rounded-lg shadow-lg p-8">
        <div className="mb-6">
          <Link to="/" className="text-blue-600 hover:text-blue-800 flex items-center mb-4">
            ← Zurück zum Formular
          </Link>
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Impressum</h1>
          
          <div className="prose max-w-none text-gray-700 space-y-4">
            <h2 className="text-xl font-semibold text-gray-900">Angaben gemäß § 5 TMG</h2>
            <p>
              Nadine Rau u. Mike Trepte GbR<br />
              Bettenhäuserstr. 1<br />
              34123 Kassel<br />
              Deutschland
            </p>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-6">Geschäftsführer</h2>
            <p>Nadine Rau, Mike Trepte</p>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-6">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p>Mike Trepte</p>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-6">Kontakt</h2>
            <p>
              Telefon: 0561 / 43027276<br />
              E-Mail: <a href="mailto:mike.trepte@managershop.com" className="text-blue-600 hover:underline">mike.trepte@managershop.com</a><br />
              Standort: Kassel, Deutschland
            </p>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-6">Umsatzsteuer-ID</h2>
            <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE338605405</p>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-6">Redaktionell verantwortlich</h2>
            <p>
              Mike Trepte<br />
              Bettenhäuserstr. 1<br />
              34123 Kassel
            </p>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-6">Haftung für Inhalte</h2>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-6">Haftung für Links</h2>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
            
            <h2 className="text-xl font-semibold text-gray-900 mt-6">Urheberrecht</h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </div>
          
          <div className="mt-8 pt-6 border-t border-gray-200">
            <Link 
              to="/" 
              className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium"
            >
              ← Zurück zur Hauptseite
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Impressum;